export enum StatusTradesEnum {
  New = 1,
  CollectionRequested = 2,
  CollectedByTheCarrier = 3,
  AwaitingAnalysis = 4,
  WithoutDivergence = 5,
  WithDivergence = 6,
  Completed = 7,
  CancellationRequested = 8,
  Canceled = 9,
  Expired = 10,
  ReturnedProduct = 11,
  AvailableInvoiceCreation = 12,
  Wms = 13,
  EntryMade = 14,
  RecertifierChecklistAvailable = 16,
  RecertifierChecklistAvailableBalloonJundSoftUnavailable = 17,
  WmsError = 18,
  Wmsf = 19,
  EntryMadeError = 20,
  SerialJundsoftIntegraded = 21,
  Misplaced = 23,
  ProductReturnInTransit = 24,
  ProductReturnMisplaced = 25
}

export enum StatusTradesQtyEnum {
  New = 'newQty',
  CollectionRequested = 'collectionRequestedQty',
  CollectedByTheCarrier = 'productCollectedByTheCarrierQty',
  AwaitingAnalysis = 'productReceivedQty',
  WithoutDivergence = 'productWithoutDivergenceQty',
  WithDivergence = 'productWithDivergenceQty',
  Completed = 'tradeCompletedQty',
  CancellationRequested = 'cancellationRequestedQty',
  Canceled = 'tradeCanceledQty',
  Expired = 'tradeExpiredQty',
  ReturnedProduct = 'returnedProductQty',
  AvailableInvoiceCreation = 'availableInvoiceCreationQty',
  Wms = 'wmsQty',
  EntryMade = 'entryMadeQty',
  RecertifierChecklistAvailable = 'recertifierChecklistAvailableQty',
  RecertifierChecklistAvailableBalloonJundSoftUnavailable = 'recertifierChecklistAvailableBalloonJundSoftUnavailableQty',
  WmsError = 'wmsErrorQty',
  Wmsf = 'wmsfQty',
  EntryMadeError = 'entryMadeErrorQty',
  SerialJundsoftIntegraded = 'serialJundsoftIntegradedQty',
  Misplaced = 'misplacedQty',
  ProductReturnInTransit = 'productReturnInTransitQty',
  ProductReturnMisplaced = 'productReturnMisplacedQty',
}

export const statusTradeText = {
  [StatusTradesEnum.New]: 'Criado',
  [StatusTradesEnum.CollectionRequested]: 'Em Postagem',
  [StatusTradesEnum.CollectedByTheCarrier]: 'Em Trânsito',
  [StatusTradesEnum.Misplaced]: 'Produto Extraviado',
  [StatusTradesEnum.AwaitingAnalysis]: 'Aguardando Triagem',
  [StatusTradesEnum.WithoutDivergence]: 'Concluído sem Divergência',
  [StatusTradesEnum.WithDivergence]: 'Concluído com Divergência',
  [StatusTradesEnum.Completed]: 'Concluído',
  [StatusTradesEnum.CancellationRequested]: 'Solicitado Cancelamento',
  [StatusTradesEnum.Canceled]: 'Cancelado',
  [StatusTradesEnum.Expired]: 'Expirado',
  [StatusTradesEnum.ReturnedProduct]: 'Devolução',
  [StatusTradesEnum.AvailableInvoiceCreation]: 'Gerar Nota',
  [StatusTradesEnum.Wms]: 'WMS - fiscal',
  [StatusTradesEnum.EntryMade]: 'Entrada Realizada',
  [StatusTradesEnum.RecertifierChecklistAvailable]: 'Aguardando Precificação',
  [StatusTradesEnum.RecertifierChecklistAvailableBalloonJundSoftUnavailable]:
  'Parc. Balão Indisponível',
  [StatusTradesEnum.WmsError]: 'Erro de Emissão de Nota',
  [StatusTradesEnum.Wmsf]: 'WMS - físico',
  [StatusTradesEnum.EntryMadeError]: 'Entrada com erro',
  [StatusTradesEnum.SerialJundsoftIntegraded]: 'Serial Integrado',
  [StatusTradesEnum.ProductReturnInTransit]: 'Devolução em Transito',
  [StatusTradesEnum.ProductReturnMisplaced]: 'Devolução Extraviada',
};

export const statusTradeColor = {
  [StatusTradesEnum.New]: '#64366B',
  [StatusTradesEnum.CollectionRequested]: '#436fff',
  [StatusTradesEnum.CollectedByTheCarrier]: '#CC0066',
  [StatusTradesEnum.AwaitingAnalysis]: '#F49819',
  [StatusTradesEnum.WithoutDivergence]: '#003366',
  [StatusTradesEnum.WithDivergence]: '#FF6600',
  [StatusTradesEnum.Completed]: '#11AF7E',
  [StatusTradesEnum.CancellationRequested]: '#EC424E',
  [StatusTradesEnum.Canceled]: '#b1000c',
  [StatusTradesEnum.Expired]: '#ff0000',
  [StatusTradesEnum.ReturnedProduct]: '#990000',
  [StatusTradesEnum.AvailableInvoiceCreation]: '#C3DD21',
  [StatusTradesEnum.Wms]: '#15A6A6',
  [StatusTradesEnum.EntryMade]: '#F6D41D',
  [StatusTradesEnum.RecertifierChecklistAvailable]: '#395037',
  [StatusTradesEnum.Wmsf]: '#15A6A6',
  [StatusTradesEnum.EntryMadeError]: '#EC424E',
  [StatusTradesEnum.SerialJundsoftIntegraded]: '#003366',
  [StatusTradesEnum.Misplaced]: '#B00101',
  [StatusTradesEnum.ProductReturnInTransit]: '#B03060',
  [StatusTradesEnum.ProductReturnMisplaced]: '#9400D3',
};

export const possibleStatusScenarioList = [
  {
    current: StatusTradesEnum.New,
    possibleFutureStatus: [
      StatusTradesEnum.CollectionRequested,
      StatusTradesEnum.CollectedByTheCarrier,
      StatusTradesEnum.AwaitingAnalysis,
      StatusTradesEnum.RecertifierChecklistAvailable,
      StatusTradesEnum.WithoutDivergence,
      StatusTradesEnum.AvailableInvoiceCreation,
      StatusTradesEnum.Wms,
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
      StatusTradesEnum.Misplaced,
    ],
  },
  {
    current: StatusTradesEnum.CollectionRequested,
    possibleFutureStatus: [
      StatusTradesEnum.CollectedByTheCarrier,
      StatusTradesEnum.AwaitingAnalysis,
      StatusTradesEnum.RecertifierChecklistAvailable,
      StatusTradesEnum.WithoutDivergence,
      StatusTradesEnum.AvailableInvoiceCreation,
      StatusTradesEnum.Wms,
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
      StatusTradesEnum.Misplaced,
    ],
  },
  {
    current: StatusTradesEnum.CollectedByTheCarrier,
    possibleFutureStatus: [
      StatusTradesEnum.AwaitingAnalysis,
      StatusTradesEnum.RecertifierChecklistAvailable,
      StatusTradesEnum.WithoutDivergence,
      StatusTradesEnum.AvailableInvoiceCreation,
      StatusTradesEnum.Wms,
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Misplaced,
    ],
  },
  {
    current: StatusTradesEnum.AwaitingAnalysis,
    possibleFutureStatus: [
      StatusTradesEnum.RecertifierChecklistAvailable,
      StatusTradesEnum.WithoutDivergence,
      StatusTradesEnum.AvailableInvoiceCreation,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Misplaced,
    ],
  },
  {
    current: StatusTradesEnum.RecertifierChecklistAvailable,
    possibleFutureStatus: [
      StatusTradesEnum.WithoutDivergence,
      StatusTradesEnum.AvailableInvoiceCreation,
      StatusTradesEnum.Wms,
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
    ],
  },
  {
    current: StatusTradesEnum.WithoutDivergence,
    possibleFutureStatus: [
      StatusTradesEnum.AvailableInvoiceCreation,
      StatusTradesEnum.Wms,
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
    ],
  },
  {
    current: StatusTradesEnum.AvailableInvoiceCreation,
    possibleFutureStatus: [
      StatusTradesEnum.Wms,
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
    ],
  },
  {
    current: StatusTradesEnum.Wms,
    possibleFutureStatus: [
      StatusTradesEnum.EntryMade,
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
    ],
  },
  {
    current: StatusTradesEnum.EntryMade,
    possibleFutureStatus: [
      StatusTradesEnum.SerialJundsoftIntegraded,
      StatusTradesEnum.Completed,
      StatusTradesEnum.Wmsf,
    ],
  },
  {
    current: StatusTradesEnum.Completed,
    possibleFutureStatus: [StatusTradesEnum.Wmsf],
  },
  {
    current: StatusTradesEnum.Wmsf,
    possibleFutureStatus: [],
  },
  {
    current: StatusTradesEnum.Expired,
    possibleFutureStatus: [],
  },
  {
    current: StatusTradesEnum.WithDivergence,
    possibleFutureStatus: [
      StatusTradesEnum.CancellationRequested,
      StatusTradesEnum.ReturnedProduct,
      StatusTradesEnum.Canceled,
    ],
  },
  {
    current: StatusTradesEnum.CancellationRequested,
    possibleFutureStatus: [StatusTradesEnum.ReturnedProduct, StatusTradesEnum.Canceled],
  },
  {
    current: StatusTradesEnum.ReturnedProduct,
    possibleFutureStatus: [StatusTradesEnum.Canceled],
  },
  {
    current: StatusTradesEnum.Canceled,
    possibleFutureStatus: [],
  },
  {
    current: StatusTradesEnum.Misplaced,
    possibleFutureStatus: [],
  },
];
